<template>
  <v-app>
    <v-navigation-drawer
      v-model="sharedState.drawer"
      light
      absolute
      width="300"
    >
      <!-- <div class="px-2 d-flex align-center">
        <v-img src="./assets/images/logo_black.png" width="50"></v-img>
        <v-spacer></v-spacer>
        <v-btn icon @click.stop="sharedState.drawer = !sharedState.drawer">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </div>
      <v-divider></v-divider> -->
      <div class="system-link px-2 py-3 mt-14">
        <router-link to="/">
          <v-btn block color="primary" class="mb-3">ドローンファイルサーバ</v-btn>
        </router-link>
        <router-link to="/pfs">
          <v-btn block color="purple darken-1" class="mb-3" dark>全国発電所点検フライトシステム</v-btn>
        </router-link>
      </div>
    </v-navigation-drawer>
    <app-bar></app-bar>
    <v-main>
      <router-view />
      <info-dialog></info-dialog>
      <confirm-dialog></confirm-dialog>
    </v-main>
    <v-overlay absolute :value="sharedState.loading" style="z-index: 203;">
      <v-progress-circular
          indeterminate
          size="64"
      ></v-progress-circular>
    </v-overlay>
  </v-app>
</template>

<script>
import {store} from './store';
import InfoDialog from "@/components/common/InfoDialog";
import ConfirmDialog from "@/components/common/ConfirmDialog";
import AppBar from "@/components/common/AppBar";

export default {
  name: "DFSApp",

  components:{
    'info-dialog': InfoDialog,
    'confirm-dialog': ConfirmDialog,
    'app-bar': AppBar,
  },

  data() {
    return {
      sharedState: store.state,
    };
  },

  methods: {
    configAxios() {
      const MAX_REQUESTS_COUNT = 5;
      const INTERVAL_MS = 40;
      let PENDING_REQUESTS = 0;
      let token = this.sharedState.token;
      //Set token for each request
      if (token) {
        this.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      }

      /**
       * Axios Request Interceptor
       */
      this.axios.interceptors.request.use((config) => {
        return new Promise((resolve) => {
          let interval = setInterval(() => {
            if (PENDING_REQUESTS < MAX_REQUESTS_COUNT) {
              PENDING_REQUESTS++;
              clearInterval(interval);
              resolve(config);
            } 
          }, INTERVAL_MS);
        })
      })

      //Handle token expire
      this.axios.interceptors.response.use(
        (response) => {
          PENDING_REQUESTS = Math.max(0, PENDING_REQUESTS - 1);
          return response;
        },
        (error) => {
          // This function is part of a promise chain.
          // It needs to return a value or another promise so the caller knows when it
          // has completed.

          PENDING_REQUESTS = Math.max(0, PENDING_REQUESTS - 1);

          // Pass all non 401s back to the caller.
          if (error.response.status === 401) {
            const url = error.config.url;
            // Logout
            if (!this.$route.path.includes("login") && !url.includes("login")) {
              this.setLogoutStatus();
              this.$router.push({
                path: '/login',
                query: { nextUrl: this.$route.path },
              });
            }
          }

          return Promise.reject(error);
        }
      );
    },
    setLogoutStatus() {
      store.updateLogoutStatus();
      this.axios.defaults.headers.common["Authorization"] = "";
    },
  },

  created() {
    this.configAxios();
  },
};
</script>

<style lang="scss">
.v-application .v-app-bar a {
  color: #fff;
  text-decoration: underline;
  font-weight: 700;
}
.v-navigation-drawer--absolute {
    z-index: 4 !important;
}
.system-link a {
  text-decoration: none;
}
.v-btn.v-btn--text {
  // text-decoration: underline;
  font-weight: 600;
}
.v-dialog .v-card__actions .v-btn:not(.v-btn--round).v-size--default {
  min-width: 100px;
}
form .v-text-field.v-text-field--enclosed.v-input--hide-details {
  margin-bottom: 15px;
}
.v-card .v-card__title {
  padding: 5px 8px 0px 8px;
  font-size: 14px;
}
.v-card .v-card__actions {
  padding: 0px 8px 8px 8px;
}
.v-card__subtitle, .v-card__text, .v-card__title {
  padding: 0px 8px;  
}
.checkEnv{
  font-size: 13px;
  margin-top: 10px;
}
.row {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}
</style>
